export default {
  path: '/',
  component: () => import('@/layouts/LayoutContentAppNav.vue'),
  meta: { protected: true },
  children: [
    {
      path: 'manage/timetable',
      name: 'ManageTimetable',
      component: () => import('@/views/timetable/ManageTimetable.vue'),
    },
    {
      path: 'manage/timetable/holidays',
      name: 'ManageHolidays',
      component: () => import('@/views/timetable/holidays/ManageHolidays.vue'),
    },
  ],
}
